import { Checkbox } from "@mui/material";
import {
    HTMLAttributes,
    useState,
    ReactElement,
    useCallback,
    MouseEvent
} from "react";
import { DangerSquare, SearchNormal, Star } from "../../assets";
import LoadingSpinner from "./loading_spinner";

interface Props extends HTMLAttributes<HTMLElement> {
    value?: any;
    title?: string,
    onChange?: any;
    myStyle?: string;
    lable?: string;
    displayEmpty?: boolean;
    placeholder?: string;
    icon?: ReactElement;
    iconBorder?: boolean;
    hasNotice?: boolean;
    item?: any;
    isRequired?: boolean;
    search?: any;
    error?: string;
    loading?: boolean;
    contentLoading?: boolean;
}

export function CustomSearch({ value, onChange, title, myStyle, lable, error, displayEmpty, placeholder, icon, loading, hasNotice, isRequired, onClick, item, search, contentLoading }: Props): ReactElement {

    const [showDropDown, setShowDropDown] = useState(false);
    const [str, setStr] = useState("");


    const handleOnClick = (item: any) => {
        onChange && onChange(item);
        setShowDropDown(false)
    }
    return (
        <div className={`${myStyle && myStyle} ${value === undefined ? "" : "checked"} custom-search`}>

            <>
                {lable &&
                  <>
                    {contentLoading ?
                        <div className="content-loading input-loading-lable">
                        </div>
                        :
                    <label className="custom-search-lable">
                        {contentLoading ? <div className="icontent-loading"></div> :
                            <>
                                {isRequired && <img src={Star} alt="هامرز"/>}  {lable}  {hasNotice && <img src={DangerSquare} alt="هامرز"/>}
                            </>

                        }
                    </label>
}
</>
}



            </>


            {contentLoading ? <div className="content-loading w-100">
            </div> :

                <div className={`${error ? "border-danger" : ""} custom-search-content`} onClick={() => setShowDropDown(true)} >
                    <div className="three-dots ">
                        <span className="custom-search-icon-border">
                            {icon}

                        </span>
                        <span className="custom-search-placeholder">
                            {value ? title : placeholder}
                        </span>

                    </div>
                    <div className="arrow arrow-up"></div>
                </div>
            }
            {error &&
                <label className="custom-search-error">
                    {error}
                </label>
            }
            {showDropDown === true ? (
                <div className="custom-search-list">
                    <div className="search-container">
                        <input
                            placeholder="جستجو کنید"
                            value={str}
                            onChange={(e) => {

                                let value = e.target.value;
                                setStr(value);

                                if (value?.trim().length > 2 )

                                    search(value)
                            }}
                        />
                        {loading ?
                            <div className="handle-loading-btn search-container-icon">
                                <LoadingSpinner />
                            </div>
                            : <img src={SearchNormal} alt="هامرز"  className="search-container-icon" />}

                    </div>
                    {item && item?.length > 0 ?
                        <ul className="ul-list">
                            {item && item.length > 0 && item?.map((item: any, index: any) => (
                                <li key={index} className="custom-search-list-item" onClick={() => handleOnClick(item)}>
                                    <a> {item.title}</a>
                                </li>
                            ))
                            }
                        </ul>
                        :

                        <p className="desc">برای جستجو حداقل سه کاراکتر وارد کنید</p>
                    }
                </div>
            ) : (null)
            }
            {showDropDown ? (<div className='overlay' onClick={() => setShowDropDown(false)} />) : null}
        </div >
    );
}

export default CustomSearch;

